import { ColumnSort } from '@tanstack/react-table';
import { SortField } from '../../queryClient';

export const transformFilter = <
  K1 extends string = string,
  K2 extends string = string
>(
  id: K1,
  value: any
) => ({ [id]: value } as Partial<Record<K2, any>>);

export const serializeSort = <T extends string = string>({
  id,
  desc,
}: ColumnSort): SortField<T> => `${id as T},${desc ? 'desc' : 'asc'}`;
